import React from 'react';
import { connect } from 'react-redux';
import { DBCheckBox, DBTextAreaObjective, DBRadioButton, ObjectiveFlag, DBDropDown, DBCheckBoxComment } from '_components';
import styles from './Common.module.css'

class SpeechSwallowing extends React.Component {

    render() {
        return (
            <div>
                    <div className={styles.formRowSetting}>
                    {this.props.flagged && <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} flagText='Swallowing' />}
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWASTATUS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                            
                            
                            <div className={styles.underHeaderRadioSpace} />

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWASTATUS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
 
                    </div>

                    <div className={styles.row}>
                        <b>Comments</b>
                    </div>

                <div className={styles.row}>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSSWACOMMENTS'
                        className={styles.commentTxtArea}
                    />
                </div>


                <div className={styles.formRowSetting}>
                    {this.props.dryFlagged && <ObjectiveFlag className={styles.flag} flagged={this.props.dryFlagged} flagText='Dry Swallow' />}
                            
                    <label className={styles.radioBtnSpacing}>Dry Swallow</label>
                            
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Present'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWADRY'
                             entityKeyValue={this.props.osno}
                             label='Present'
                             className={styles.radio}
                            />   
                            
                            
                            <div className={styles.radioRowSpace} />

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWADRY'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   

                            <div className={styles.radioBtnSpacing} />
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Absent'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWADRY'
                             entityKeyValue={this.props.osno}
                             label='Absent'
                             className={styles.radio}
                            />  
 
                </div>

                <div className={styles.formRowSetting}>
                    {this.props.liquidFlagged && <ObjectiveFlag className={styles.flag} flagged={this.props.liquidFlagged} flagText='Liquids' />}
                            
                    <label className={styles.radioBtnSpacing}>Liquids</label>
                            
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWALIQUID'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                            
                            
                             <div className={styles.radioBtnSpacing} />

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWALIQUID'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   

                            <div className={styles.radioBtnSpacing} />
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Unable'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWALIQUID'
                             entityKeyValue={this.props.osno}
                             label='Unable'
                             className={styles.radio}
                            />  
 
                </div>

                <div className={styles.formRowSetting}>
                    {this.props.pureeFlagged && <ObjectiveFlag className={styles.flag} flagged={this.props.pureeFlagged} flagText='Puree' />}
                            
                    <label className={styles.radioBtnSpacing}>Puree</label>
                            
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWAPUREE'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                            
                            
                             <div className={styles.radioBtnSpacing} />

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWAPUREE'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   

                            <div className={styles.radioBtnSpacing} />
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Unable'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWAPUREE'
                             entityKeyValue={this.props.osno}
                             label='Unable'
                             className={styles.radio}
                            />  
 
                </div>


                <div className={styles.formRowSetting}>
                    {this.props.mechanicalSoftFlagged && <ObjectiveFlag className={styles.flag} flagged={this.props.mechanicalSoftFlagged} flagText='Mechanical Soft' />}
                            
                    <label className={styles.radioBtnSpacing}>Mechanical Soft</label>
                            
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWAMECHANICAL'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                            
                            
                             <div className={styles.radioBtnSpacing} />

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWAMECHANICAL'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   

                            <div className={styles.radioBtnSpacing} />
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Unable'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWAMECHANICAL'
                             entityKeyValue={this.props.osno}
                             label='Unable'
                             className={styles.radio}
                            />  
 
                </div>

                <div className={styles.formRowSetting}>
                    {this.props.softFlagged && <ObjectiveFlag className={styles.flag} flagged={this.props.softFlagged} flagText='Soft' />}
                            
                    <label className={styles.radioBtnSpacing}>Soft</label>
                            
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWASOFT'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                            
                            
                             <div className={styles.radioBtnSpacing} />

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWASOFT'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   

                            <div className={styles.radioBtnSpacing} />
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Unable'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWASOFT'
                             entityKeyValue={this.props.osno}
                             label='Unable'
                             className={styles.radio}
                            />  
 
                </div>

                <div className={styles.formRowSetting}>
                    {this.props.regularFoodFlagged && <ObjectiveFlag className={styles.flag} flagged={this.props.regularFoodFlagged} flagText='Regular Food' />}
                            
                    <label className={styles.radioBtnSpacing}>Regular Food</label>
                            
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWAREGULAR'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                            
                            
                             <div className={styles.radioBtnSpacing} />

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWAREGULAR'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   

                            <div className={styles.radioBtnSpacing} />
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Unable'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWAREGULAR'
                             entityKeyValue={this.props.osno}
                             label='Unable'
                             className={styles.radio}
                            />  
 
                </div>

                <div className={styles.formRowSetting}>
                    {this.props.pocketingFlagged && <ObjectiveFlag className={styles.flag} flagged={this.props.pocketingFlagged} flagText='Pocketing' />}
                            
                    <label className={styles.radioBtnSpacing}>Pocketing</label>
                            
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'No'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWAPOCKET'
                             entityKeyValue={this.props.osno}
                             label='No'
                             className={styles.radio}
                            />   

                            <div className={styles.radioGap} />
                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Right'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWAPOCKET'
                             entityKeyValue={this.props.osno}
                             label='Right'
                             className={styles.radio}
                            />   

                            <div className={styles.radioRightBtnSpace} />
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Left'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSSWAPOCKET'
                             entityKeyValue={this.props.osno}
                             label='Left'
                             className={styles.radio}
                            />  
 
                </div>
            
                <div className={styles.formRowSetting}>
                    {this.props.coughFlagged 
                    ? 
                    <ObjectiveFlag className={styles.flag} flagged={this.props.coughFlagged} flagText='Cough' /> : <div className={styles.flag}/>}
                        
                            
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSSWACOUGH'
                        label='Cough'
                    />

                    <DBDropDown
                        field='OSSWACOUGHTYPE'
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        customOptions={
                            [
                                {id: 1, value: 'WNL'},
                                {id: 2, value: 'WFL'},
                                {id: 3, value: 'Productive'},
                                {id: 4, value: 'Strong'},
                                {id: 5, value: 'Weak'},
                                {id: 6, value: 'Absent'},
                            ]
                        }
                    />
 
                </div>

                <div className={styles.row}>
                <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSSWAMBSS'
                         className={styles.checkbox}
                         label='MBSS'
                         textAreaStyle={styles.textAreaStyle}
                    />
                </div>

                <div className={styles.row}>
                <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSSWAVFSS'
                         className={styles.checkbox}
                         label='VFSS'
                         textAreaStyle={styles.textAreaStyle}
                    />
                </div>

                <div className={styles.row}>
                <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSSWAFEES'
                         className={styles.checkbox}
                         label='FEES'
                         textAreaStyle={styles.textAreaStyle}
                    />
                </div>

            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let osno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPEECH)
    .find(key => (state.entities.notes.PTOBJECTIVESPEECH[key].OSEVNO === pk && noteType === 1)
        || (state.entities.notes.PTOBJECTIVESPEECH[key].OSNTNO === pk && noteType !== 1)));
    return {
        noteId: noteId,
        osno: osno,
        flagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWASTATUS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWASTATUS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWASTATUS !== 'WNL'),
        dryFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWADRY !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWADRY !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWADRY !== 'Present'),
        liquidFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWALIQUID !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWALIQUID !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWALIQUID !== 'WNL'),
        pureeFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWAPUREE !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWAPUREE !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWAPUREE !== 'WNL'),
        mechanicalSoftFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWAMECHANICAL !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWAMECHANICAL !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWAMECHANICAL !== 'WNL'),
        softFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWASOFT !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWASOFT !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWASOFT !== 'WNL'),
        regularFoodFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWAREGULAR !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWAREGULAR !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWAREGULAR !== 'WNL'),
        pocketingFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWAPOCKET !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWAPOCKET !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWAPOCKET !== 'No'),
        coughFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWACOUGHTYPE !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWACOUGHTYPE !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWACOUGHTYPE !== '1' && state.entities.notes.PTOBJECTIVESPEECH[osno].OSSWACOUGHTYPE !== '2')
    };
    
}

const connectedSpeechSwallowing = connect(mapStateToProps)(SpeechSwallowing);
export { connectedSpeechSwallowing as SpeechSwallowing };


